<template>
  <div>
    <Header />
    <main>
      <section class="shop">
        <i class="fas fa-shield-alt"></i>
        <h1>Safety</h1>
      </section>
      <section class="safety-info">
        <div class="image-scroll">
          <img v-for="n in 5" :key="n" :src="`/assets/png${n}.png`" :alt="`Safety Image ${n}`" />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'

export default {
  name: 'Safety',
  components: {
    Header
  },
  metaInfo() {
    return {
      title: "Safety | ShopT"
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
  color: #fff;
}

.safety-info {
  width: 100%;
  max-width: 1200px;
  margin-top: 2rem;
  padding: 2rem;
  background-color: #222;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.safety-info p {
  font-size: 1.4rem;
  line-height: 2;
  color: #ccc;
  margin-bottom: 2rem;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  gap: 2rem;
  padding-bottom: 1rem;
  scroll-snap-type: x mandatory;
}

.image-scroll img {
  height: 500px;
  max-width: none;
  border-radius: 12px;
  flex-shrink: 0;
  scroll-snap-align: start;
  object-fit: contain;
  border: 3px solid #555;
  box-shadow: 0 4px 10px rgba(0,0,0,0.5);
}

.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
